exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._34viWT8YXbQ9vfjcThRxlX{text-align:left;font-size:14px;line-height:20px;padding:10px 15px;width:100%;display:flex;flex-direction:row}.nnagyh3KwMA2GskJd8jNU{flex:1 1 auto}._3_3lf3BB7xwEGzN_bZ1eQe{flex:1 0 100px;height:100px}\n", ""]);

// Exports
exports.locals = {
	"content": "_34viWT8YXbQ9vfjcThRxlX",
	"left": "nnagyh3KwMA2GskJd8jNU",
	"right": "_3_3lf3BB7xwEGzN_bZ1eQe"
};